import React from "react";
import "./Slider.css";
const Slider = ({ value, handleChange }) => {
  return (
    <div className="slider" style={{width:'90%',}}>
      <input
        type="range"
        value={value}
        onChange={(evt) => handleChange(evt.target.value)}
      />
      <input
        min='0'
        max={100}
        type="number"
        value={value}
        onChange={(evt) => handleChange(evt.target.value)}
      />
      <span>Px</span>
    </div>
  );
};

export default Slider;
